
import React from 'react';
import { Send } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CreatePostButton = () => {
  return (
    <div className="px-6 pb-6 pt-4">
      <Button
        variant="outline"
        className="w-full flex items-center justify-center gap-2 text-[#8b5cf6] dark:text-[#a78bfa] border-[#d4c5ff] dark:border-[#8b5cf6]/40 dark:hover:bg-[#8b5cf6]/20 hover:bg-[#f5f0ff] hover:border-[#8b5cf6] dark:hover:border-[#a78bfa]/60 transition-colors"
        onClick={() => {
          // Handle create post action
          console.log("Create post clicked");
        }}
      >
        <Send className="w-4 h-4" />
        <span>Créer un post</span>
      </Button>
    </div>
  );
};

export default CreatePostButton;
